// extracted by mini-css-extract-plugin
export var headerXL = "SectionBlogSuggestions-module--headerXL--2uwPF";
export var headerL = "SectionBlogSuggestions-module--headerL--2YkCI";
export var headerM = "SectionBlogSuggestions-module--headerM--38Eet";
export var headerS = "SectionBlogSuggestions-module--headerS--3q8Ee";
export var headerXS = "SectionBlogSuggestions-module--headerXS--392w9";
export var blogHeaderXL = "SectionBlogSuggestions-module--blogHeaderXL--1rPVu";
export var blogHeaderL = "SectionBlogSuggestions-module--blogHeaderL--3xqhO";
export var blogHeaderM = "SectionBlogSuggestions-module--blogHeaderM--1Bw2e";
export var blogHeaderS = "SectionBlogSuggestions-module--blogHeaderS--12217";
export var blogHeaderXS = "SectionBlogSuggestions-module--blogHeaderXS--37q8u";
export var headerPreamble = "SectionBlogSuggestions-module--headerPreamble--3MxZT";
export var preHeader = "SectionBlogSuggestions-module--preHeader--3kmep";
export var textNormal = "SectionBlogSuggestions-module--textNormal--2cdWU";
export var textSmall = "SectionBlogSuggestions-module--textSmall--2iITr";
export var textSmallAlternate = "SectionBlogSuggestions-module--textSmallAlternate--3_nbe";
export var legend = "SectionBlogSuggestions-module--legend--2Xd30";
export var caption = "SectionBlogSuggestions-module--caption--2IPeV";
export var gradientBackground = "SectionBlogSuggestions-module--gradientBackground--pkmuA";
export var ellipsis = "SectionBlogSuggestions-module--ellipsis--LzlPQ";
export var globalContainer = "SectionBlogSuggestions-module--globalContainer--3gyzI";
export var maxWidth = "SectionBlogSuggestions-module--maxWidth--8y9SL";
export var clipBottom = "SectionBlogSuggestions-module--clipBottom--3x6QC";
export var clipTopBottom = "SectionBlogSuggestions-module--clipTopBottom--3inIi";
export var blogSuggestions = "SectionBlogSuggestions-module--blogSuggestions--DKG9x";
export var content = "SectionBlogSuggestions-module--content--2_Ojb";
export var textBlock = "SectionBlogSuggestions-module--textBlock--2zPTA";
export var ch2 = "SectionBlogSuggestions-module--ch2--2niJ9";
export var ch2Container = "SectionBlogSuggestions-module--ch2-container--2glNo";